module.exports = __webpack_public_path__ + "img/5-4.ecc44a00.png";